class fileUploadController {
  constructor($element, $scope, $q) {
    'ngInject';
    this.$element = $element;
    this.$scope = $scope;
    this.$q = $q;
    this.name = 'fileUpload';
  }

  $onInit() {
    //check if this browser support grag-n-drop
    const isAdvancedUpload = function() {
      let div = document.createElement('div');
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    }();

    if (isAdvancedUpload) {
      this.$element.children().addClass('has-advanced-upload');
      this.form = this.$element.children().children();

      //add visual effects of file-dragging
      this.form.on('drag dragstart dragend dragover dragenter dragleave drop', (e) => {
        e.preventDefault();
        e.stopPropagation();
      })
      //add visual effects of file-dragging
      .on('dragover dragenter', () => {
        this.form.addClass('is-dragover');
      })
      //add visual effects of file-dragging
      .on('dragleave dragend drop', () => {
        this.form.removeClass('is-dragover');
      })
      .on('change', this.handleFileChoose.bind(this))
      .on('drop', this.handleFileDrop.bind(this))
    }
  }

  handleFileChoose(e) {
    this.file = e.target.files[0];
    this.$scope.$apply();
    return this.file;
  }

  handleFileDrop(e) {
    this.file = e.dataTransfer.files[0];
    this.$scope.$apply();
    return this.file;
  }

  fileChoosed() {
    this.handleFileUploaded({file: this.file});
  }
}

export default fileUploadController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/screens/task-detail-info/components/file-upload/file-upload.controller.js